var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOffOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye-off-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.875,
    height: 18.286,
    viewBox: "0 0 22.875 18.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M81.763,82.575a.755.755,0,0,1-.537-.223L64.5,65.577A.761.761,0,0,1,65.574,64.5L82.3,81.274a.763.763,0,0,1-.537,1.3Z",
    transform: "translate(-61.961 -64.29)",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M27.533,171.547a10.428,10.428,0,0,1-5.732-1.759,14.529,14.529,0,0,1-4.275-4.386v0a17.538,17.538,0,0,1,3.145-3.481.1.1,0,0,0,.007-.142l-.96-.959a.1.1,0,0,0-.131-.006,19.115,19.115,0,0,0-3.33,3.708,1.539,1.539,0,0,0-.031,1.713,16.1,16.1,0,0,0,4.737,4.851,11.94,11.94,0,0,0,6.57,2.007,11.526,11.526,0,0,0,3.654-.606.1.1,0,0,0,.037-.16l-1.04-1.04a.193.193,0,0,0-.185-.048,9.872,9.872,0,0,1-2.466.312Z",
    transform: "translate(-15.98 -156.347)",
    fill: "#747474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M194.438,102.873a16.337,16.337,0,0,0-4.785-4.846A12.109,12.109,0,0,0,183.1,96a10.958,10.958,0,0,0-3.61.618.1.1,0,0,0-.036.16l1.039,1.039a.193.193,0,0,0,.187.048,9.294,9.294,0,0,1,2.42-.322,10.424,10.424,0,0,1,5.714,1.783,14.784,14.784,0,0,1,4.327,4.386.006.006,0,0,1,0,.008,14.977,14.977,0,0,1-3.091,3.506.1.1,0,0,0-.007.142l.959.959a.1.1,0,0,0,.13.006,16.556,16.556,0,0,0,3.309-3.783A1.552,1.552,0,0,0,194.438,102.873Z",
    transform: "translate(-171.811 -94.472)",
    fill: "#747474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M234.143,160a4.622,4.622,0,0,0-1.03.116.1.1,0,0,0-.048.163l5.427,5.426a.1.1,0,0,0,.163-.048A4.627,4.627,0,0,0,234.143,160Z",
    transform: "translate(-222.732 -155.462)",
    fill: "#747474"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M160.258,233.1a.1.1,0,0,0-.163.048,4.627,4.627,0,0,0,5.543,5.543.1.1,0,0,0,.048-.163Z",
    transform: "translate(-153.142 -225.065)",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffOutline);
export default __webpack_public_path__ + "static/media/eye-off-outline.181a907e4af184c52bedda49d91ab611.svg";
export { ForwardRef as ReactComponent };